import { render, staticRenderFns } from "./ProgramsListItem.vue?vue&type=template&id=b41a213c&"
import script from "./ProgramsListItem.vue?vue&type=script&lang=js&"
export * from "./ProgramsListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports